<template>
  <div class="quote__travel">
    <div class="quote__travel-header">
      <div class="quote__travel-top">
        <div class="quote__title">{{ $t('qic_travel_dates') }}</div>
        <div class="quote__travel-date">{{ formatedDate(start) || '12.04.2022' }} - {{ formatedDate(end) || '22.04.2022' }}</div>
      </div>
      <div class="quote__travel-desc"> {{ destination || 'Destination: Russian Federation' }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuoteTravelDates',
  props: [
    'start',
    'end',
    'destination'
  ],
  methods: {
    formatedDate (current) {
      if (!current) return ''
      const date = new Date(current)
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${year}`
    }
  }
}
</script>
